import React, { useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet";
import { Box, Tabs as MuiTabs, Tab as MuiTab, Typography as MuiTypography } from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { useLocation } from "react-router-dom";

import { useAuth } from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import { GET_APP_LOCALIZE_TEXT } from "../../../utils/dq_lc_service/lc_service";

import AboutThisReportTab from "./components/AboutThisReportTab.comp";
import AboutReadinessTab from "./components/AboutReadinessTab.comp";
import ScoringRubricTab from "./components/ScoringRubricTab.comp";
import {makeStyles} from "@material-ui/core/styles";

const Tabs = styled(MuiTabs)(spacing);
const Tab = styled(MuiTab)(spacing);
const Typography = styled(MuiTypography)(spacing);

const useStyles = makeStyles(theme => ({
    root:{
        backgroundColor: "grey",
        color: theme.palette.secondary.contrastText,
        margin: "0px 1px 0px 1px",
        padding: "0px 0px 0px 0px",
        minWidth: "auto",
        minInlineSize: "auto",

        "&.Mui-selected": {
            backgroundColor: theme.sidebar.background,
            color: theme.palette.secondary.contrastText,

        }
    },

    indicator: {
        backgroundColor: "primary",
        height: "100%",
        opacity: "0%",
        width: "100%",
    },

    link: {

    }
}));


function TabPanel({ children, value, index }) {
    return value === index && <Box py={3}>{children}</Box>;
}

const TAB_DEFS = () => [
    { key: "about_this_report", label: "1. ABOUT THIS REPORT", component: <AboutThisReportTab /> },
    { key: "about_readiness", label: "2. ABOUT AI READINESS ASSESSMENT", component: <AboutReadinessTab /> },
    { key: "scoring_rubric", label: "3. SCORING RUBRIC", component: <ScoringRubricTab /> },
];
function ReportOverviewSchool() {
    const { authUser } = useAuth();
    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const classes = useStyles();
    const tabDefs = TAB_DEFS();

    return (
        <React.Fragment>
            <Helmet title={`DQ-PRO | Report Overview`} />
            <Box width="100%" py={4}>
                <Tabs
                    value={tab}
                    onChange={(e, newTab) => setTab(newTab)}
                    TabIndicatorProps={{ className: classes.indicator }} style={{paddingLeft: "30px", paddingRight: "30px"}}
                    centered
                    variant="fullWidth"
                    scrollButtons="auto"
                    aria-label="styled tabs example"
                >
                    {tabDefs.map((tabDef, idx) => (
                        <Tab
                            key={tabDef.key}
                            label={tabDef.label}
                            style={{ fontWeight: "bold", fontSize: 16, minWidth: 200 }}
                            classes={{root: classes.root}}
                        />
                    ))}
                </Tabs>
                <Box mt={3}>
                    {tabDefs.map((tabDef, idx) => (
                        <TabPanel key={tabDef.key} value={tab} index={idx}>
                            {tabDef.component}
                        </TabPanel>
                    ))}
                </Box>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </React.Fragment>
    );
}

export default ReportOverviewSchool;